import { render, staticRenderFns } from "./ModalDeleteReason.vue?vue&type=template&id=151614c8&"
import script from "./ModalDeleteReason.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteReason.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports